const addDisplayClass = function(element, media) {
	window.addEventListener('resize', () => {
		if(media.matches) {
			element.classList.add('accordion-active');
			return;
		}

		element.classList.remove('accordion-active');
	});

	if(media.matches) {
		element.classList.add('accordion-active');
		return;
	}

	element.classList.remove('accordion-active');
}

const closeAccordion = function(trigger, contentWrap) {
	trigger.classList.remove('a-open');
	contentWrap.classList.remove('open');
	contentWrap.style.height = '';
}

const openAccordion = function(trigger, contentWrap, content) {
	trigger.classList.add('a-open');
	contentWrap.classList.add('open');
	contentWrap.style.height = content.offsetHeight + 'px';
}

const addAccordionEvents = function(element, media) {
	const triggers = element.querySelectorAll('ul.tabs > li > a');
	const wrappers = element.querySelectorAll('.woo-product-tab-accordion');
	const contents = element.querySelectorAll('.woo-product-tab-accordion-content');

	for (let i = 0; i < triggers.length; i++) {
		const element = triggers[i];

		if(element.parentNode.classList.contains('active')) {
			openAccordion(element, wrappers[i], contents[i]);
		}

		element.addEventListener('click', () => {
			for (let z = 0; z < triggers.length; z++) {
				const potentialActive = triggers[z];
				if(potentialActive.classList.contains('a-open')) {
					closeAccordion(potentialActive, wrappers[z]);
				}
			}

			openAccordion(element, wrappers[i], contents[i]);
		});
	}

	window.addEventListener('resize', () => {
		for (let y = 0; y < wrappers.length; y++) {
			const element = wrappers[y];

			if(element.classList.contains('open')) {
				element.style.height = contents[y].offsetHeight + 'px';

				continue;
			}

			element.style.height = '';
		}
	});
}

const tabsToAccordionInit = function() {
	const tabs = document.querySelectorAll('.woocommerce-tabs');
	let media = window.matchMedia('(max-width: 768px)');

	for (let i = 0; i < tabs.length; i++) {
		const element = tabs[i];
		element.classList.add('initialized');

		addDisplayClass(element, media);
		addAccordionEvents(element, media);
	}
}

export default tabsToAccordionInit;